import PropTypes from "prop-types";
import { Fragment, memo } from "react";
import { ficheProduitPropTypes, resolutionPropType } from "app/utils/propTypes";
import HomeDesktop from "@brand/Home/desktop/HomeDesktop";
import HomeMobile from "@brand/Home/mobile/HomeMobile";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { useMatch } from "react-router-dom";
import ReasonToBookBlockContainer from "app/pages/.shared/ReasonsToBook/ReasonToBookBlock/ReasonToBookBlockContainer";
import "./Home.scss";

const Home = props => {
	const { resolution } = props;

	const loginMatch = useMatch({
		path: "/home/login",
		caseSensitive: true,
	});

	const signupMatch = useMatch({
		path: "/home/signup",
		caseSensitive: true,
	});

	return (
		<Fragment>
			{loginMatch && <HeadMetadata page="login" />}
			{signupMatch && <HeadMetadata page="signup" />}

			{resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM ? (
				<HomeMobile {...props} />
			) : (
				<HomeDesktop {...props} />
			)}

			<div className="home__rtb">
				<ReasonToBookBlockContainer />
			</div>
		</Fragment>
	);
};

Home.propTypes = {
	auth: PropTypes.element,
	shop: PropTypes.string,
	onGoingProductCount: PropTypes.number,
	resolution: resolutionPropType,
	products: PropTypes.arrayOf(ficheProduitPropTypes),
	brandDisplayName: PropTypes.string,
};

export default memo(Home);
